import { render, staticRenderFns } from "./rechargeCard.vue?vue&type=template&id=870ca4f6&scoped=true&"
import script from "./rechargeCard.vue?vue&type=script&lang=js&"
export * from "./rechargeCard.vue?vue&type=script&lang=js&"
import style0 from "./rechargeCard.vue?vue&type=style&index=0&id=870ca4f6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870ca4f6",
  null
  
)

export default component.exports